import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailCapture({
  variant = "band",
  heading = "Stay in touch.",
  body = "",
  buttonLabel = "Subscribe",
  testIdPrefix = "newsletter",
}) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("An email, please");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Thank you. We'll be in touch.");
      setEmail("");
    } catch (err) {
      toast.error(
        err?.response?.data?.detail
          ? "That email didn't take. Try again?"
          : "Something didn't go through. Try again?"
      );
    } finally {
      setLoading(false);
    }
  };

  if (variant === "inline") {
    return (
      <form
        onSubmit={onSubmit}
        data-testid={`${testIdPrefix}-form`}
        className="flex flex-col sm:flex-row items-stretch gap-4 sm:gap-6 max-w-xl"
      >
        <label className="sr-only" htmlFor={`${testIdPrefix}-email`}>
          Email
        </label>
        <input
          id={`${testIdPrefix}-email`}
          type="email"
          required
          placeholder="your@email.address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid={`${testIdPrefix}-email-input`}
          className="input-rule flex-1"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid={`${testIdPrefix}-submit-button`}
          className="btn-ink"
        >
          {loading ? "Sending…" : buttonLabel}
        </button>
      </form>
    );
  }

  return (
    <section
      data-testid={`${testIdPrefix}-band`}
      className="py-24 md:py-32"
      style={{ backgroundColor: "var(--paper-deep)" }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-12 text-center">
        <h2
          className="font-serif-lit text-3xl sm:text-4xl md:text-5xl tracking-tight"
          style={{ color: "var(--ink)", fontWeight: 500 }}
        >
          {heading}
        </h2>
        {body && (
          <p
            data-testid={`${testIdPrefix}-body`}
            className="font-serif-lit text-lg md:text-xl leading-relaxed mt-6 max-w-2xl mx-auto"
            style={{ color: "var(--ink-soft)" }}
          >
            {body}
          </p>
        )}
        <form
          onSubmit={onSubmit}
          data-testid={`${testIdPrefix}-form`}
          className="mt-10 flex flex-col sm:flex-row items-stretch gap-4 sm:gap-6 max-w-xl mx-auto"
        >
          <label className="sr-only" htmlFor={`${testIdPrefix}-email`}>
            Email
          </label>
          <input
            id={`${testIdPrefix}-email`}
            type="email"
            required
            placeholder="your@email.address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid={`${testIdPrefix}-email-input`}
            className="input-rule flex-1"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid={`${testIdPrefix}-submit-button`}
            className="btn-ink"
          >
            {loading ? "Sending…" : buttonLabel}
          </button>
        </form>
      </div>
    </section>
  );
}
